import { getPrescriptionsForPatient } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  GetPrescriptionsForPatientParams,
  PaginatedPrescriptionsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPrescriptionsForPatient(
  userId: string,
  params?: GetPrescriptionsForPatientParams,
  signal?: AbortSignal
): Promise<PaginatedPrescriptionsResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPrescriptionsForPatient(userId, params, config);
  return lotusHealthZod.getPrescriptionsForPatientResponse.parse(
    response.data
  ) as PaginatedPrescriptionsResponseT;
}
